import React from 'react';
import { Route, Switch } from 'react-router-dom';

import http from 'api/http';
import {oilAPI} from 'api/requests';

import { ROUTE } from 'constants/routing';
import NotFoundScene from 'Scenes/NotFoundScene';
import FormulaCreate from './Create';
import FormulaDetails from './Details';
import FormulaEdit from './Edit';
import {ROLES} from 'constants/roles';

class OilFormulatorRouter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      manufacturerAddressesWithCurrent: [],
    };
  }

  componentDidMount() {
    const { match } = this.props;

    if (isFinite(match.params.applicationId)) {
      http.get(oilAPI.formula(match.params.applicationId)).then(({ data }) => {
        this.setState({ applicationData: data });
      });
    }
  }

  componentDidUpdate() {
    if (
      !this.state.manufacturerAddressesWithCurrent.length &&
      this.state.applicationData &&
      this.props.manufacturerAddresses
    )
      this.updateAddressesList();
  }

  updateAddressesList = () => {
    const { manufacturerAddresses } = this.props;
    const { manufacturerAddress } = this.state.applicationData;

    let manufacturerAddressesWithCurrent = [...manufacturerAddresses];

    if (manufacturerAddress) {
      let address = manufacturerAddresses.find(address => {
        let isSame = true;
        Object.keys(address.value).forEach(addressField => {
          if (address.value[addressField] !== manufacturerAddress[addressField]) isSame = false;
        });
        return isSame;
      });

      if (!address) {
        address = {
          name: [
            manufacturerAddress.address1,
            manufacturerAddress.address2,
            manufacturerAddress.address3,
            manufacturerAddress.address4,
            manufacturerAddress.city,
            manufacturerAddress.state,
            manufacturerAddress.postalCode,
            manufacturerAddress.country,
          ]
            .filter(object => object)
            .join(', '),
          value: { ...manufacturerAddress },
        };

        if (address.name) {
          manufacturerAddressesWithCurrent.unshift(address);
        }
      }
    }

    this.setState({ manufacturerAddressesWithCurrent });
  };

  updateApplicationData = data => {
    const { updateSingleListEntry, match } = this.props;
    updateSingleListEntry(match.params.applicationId)(data);
    this.setState({ applicationData: data });
  };

  renderScene = Scene => {
    const { manufacturerAddresses } = this.props;
    const { applicationData, manufacturerAddressesWithCurrent } = this.state;
    return ({ match }) => {
      return (
        <Scene
          {...this.props}
          manufacturerAddresses={
            isFinite(match.params.applicationId) ? manufacturerAddressesWithCurrent : manufacturerAddresses
          }
          applicationData={applicationData}
          updateApplicationData={this.updateApplicationData}
          match={match}
        />
      );
    };
  };

  render() {
    const rootRoute = `${ROUTE.OIL_MANUFACTURER}${ROLES.OIL_MANUFACTURER.listSceneUrlPostfix}`;
    return (
      <Switch>
        <Route exact path={`${rootRoute}/new`} render={this.renderScene(FormulaCreate)} />
        <Route exact path={`${rootRoute}/:applicationId`} render={this.renderScene(FormulaDetails)} />
        <Route exact path={`${rootRoute}/:applicationId/edit`} render={this.renderScene(FormulaEdit)} />
        <Route render={this.renderScene(NotFoundScene)} />
      </Switch>
    );
  }
}

export default OilFormulatorRouter;



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/formula/Application/index.jsx